var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"block w-full pb-1 font-semibold leading-normal text-gray-700 text-14px",class:{ 'text-gray-700': !!_vm.error, 'text-red-600': !!_vm.error }},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }